import React, { Component } from 'react';
import {PropTypes} from 'prop-types';

class BusinessContentItem extends Component {

  render() {
    return (
      <div className='business-content'>
        <h3 className='business-content-title'>{this.props.title}</h3>
        <div className='business-content-detail' dangerouslySetInnerHTML={{__html: this.props.content}}></div>
      </div>
    );
  }

}

BusinessContentItem.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired
}

export default BusinessContentItem;



// WEBPACK FOOTER //
// ./components/business/business-page/BusinessContentItem.jsx